import z from "zod";
import { PaginationResponseSchema, PaginationSchema } from "../common";
import { ProjectOrderByEnum } from "./common";
import { PublicProjectSchema, PublicProjectSummarySchema } from "./entity";
import { ListProjectFilter, ProjectRoomFilterOptionsSchema } from "./filter";

export const PublicProjectSchemas = {
  filterOptions: {
    request: z.object({}),
    response: ProjectRoomFilterOptionsSchema,
  },

  find: {
    request: z.object({ id: z.uuidv7() }),
    response: PublicProjectSchema,
  },

  findByCode: {
    request: z.object({ code: z.string() }),
    response: PublicProjectSchema,
  },

  list: {
    filter: ListProjectFilter,
    request: PaginationSchema.extend({ ...ListProjectFilter.shape, orderBy: ProjectOrderByEnum }),
    response: PaginationResponseSchema(PublicProjectSummarySchema),
  },

  map: {
    request: ListProjectFilter,
    response: z
      .object({
        id: z.uuidv7(),
        code: z.string(),
        lat: z.number(),
        lng: z.number(),
        minPrice: z.number(),
        title: z.string(),
        slug: z.string().optional(),
        image: z.string().optional(),
        altText: z.string().optional(),
        city: z.string(),
        district: z.string(),
      })
      .array(),
  },
};

export type ListPublicProjectsRequest = z.infer<typeof PublicProjectSchemas.list.request>;

export type PublicProject = z.infer<typeof PublicProjectSchema>;
export type PublicProjectSummary = z.infer<typeof PublicProjectSummarySchema>;
